import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "D:/personal/githubrepo/rx-form-state/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { useFormState, FormStateContext, Field } from '../src';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "sinouirx-form-state"
    }}>{`@sinoui/rx-form-state`}</h1>
    <p><inlineCode parentName="p">{`@sinoui/rx-form-state`}</inlineCode>{`是用来管理表单状态的库。`}</p>
    <h2 {...{
      "id": "快速入门"
    }}>{`快速入门`}</h2>
    <h3 {...{
      "id": "安装"
    }}>{`安装`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`yarn add @sinoui/rx-form-state
`}</code></pre>
    <h3 {...{
      "id": "入门示例"
    }}>{`入门示例`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React from 'react';
import { useFormState, FormStateContext, Field } from '@sinoui/rx-form-state';

function FormDemo() {
  const initialValue = {}; // 表单默认值
  const options = {}; // 创建表单状态管理器的配置
  const formState = useFormState(initialValue, options);

  return (
    <FormStateContext.Provider value={formState}>
      <form>
        <label>
          姓名:
          <Field as="input" name="userName" required />
        </label>
        <label>
          年龄：
          <Field as="input" name="age" required />
        </label>
      </form>
    </FormStateContext.Provider>
  );
}
`}</code></pre>
    <Playground __position={0} __code={'() => {\n  const formState = useFormState()\n  return (\n    <FormStateContext.Provider value={formState}>\n      <form>\n        <div>\n          <label>\n            姓名：\n            <Field as=\"input\" name=\"userName\" required />\n          </label>\n        </div>\n        <div>\n          <label>\n            年龄：\n            <Field as=\"input\" name=\"age\" required />\n          </label>\n        </div>\n      </form>\n    </FormStateContext.Provider>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      useFormState,
      FormStateContext,
      Field,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const formState = useFormState();
        return <FormStateContext.Provider value={formState}>
        <form>
          <div>
            <label>
              姓名：
              <Field as="input" name="userName" required mdxType="Field" />
            </label>
          </div>
          <div>
            <label>
              年龄：
              <Field as="input" name="age" required mdxType="Field" />
            </label>
          </div>
        </form>
      </FormStateContext.Provider>;
      }}
    </Playground>
    <p>{`使用`}<a parentName="p" {...{
        "href": "api-use-form-state"
      }}>{`useFormState`}</a>{`创建表单状态管理器对象，通过`}<a parentName="p" {...{
        "href": "api-form-state-context"
      }}>{`FormStateContext`}</a>{`加入到表单上下文中。
通过`}<a parentName="p" {...{
        "href": "api-field-component"
      }}>{`Field`}</a>{`组件管理单个表单域。
还可以通过`}<a parentName="p" {...{
        "href": "api-use-field-array"
      }}>{`useFieldArray`}</a>{`和`}<a parentName="p" {...{
        "href": "api-field-array-component"
      }}>{`FieldArray`}</a>{`实现嵌套表单。`}</p>
    <p>{`@sinoui/rx-form-state 可以在 React 和 React native 中使用。可以与多种 UI 库组合使用，如`}<a parentName="p" {...{
        "href": "https://material-ui.com/"
      }}>{`material-ui`}</a>{`、`}<a parentName="p" {...{
        "href": "https://ant.design/index-cn"
      }}>{`ant design`}</a>{`和 `}<a parentName="p" {...{
        "href": "https://github.com/sinoui/core"
      }}>{`@sinoui/core`}</a>{`。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      